import type { QueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import type { RelayChatExtension } from '@inference.engine/agentic-react';
import { TAXONOMY_SCHEMA_CHANGED_PART } from '@inference.engine/taxonomy/web';
import { TAXONOMY_QUERY_KEYS } from './query-keys';

const schemaChangedSchema = z.object({ taxonomyId: z.string() });

/**
 * Reads a schema again when an agent says it changed it, so the schema's page follows the agent.
 * Given `onlyTaxonomyId`, other schemas' changes are left alone.
 */
export function schemaChangedExtension(
  queryClient: QueryClient,
  onlyTaxonomyId?: string,
): RelayChatExtension {
  return {
    part: `data-${TAXONOMY_SCHEMA_CHANGED_PART}`,
    onPart: (data) => {
      const parsed = schemaChangedSchema.safeParse(data);
      if (!parsed.success) return;
      if (onlyTaxonomyId && parsed.data.taxonomyId !== onlyTaxonomyId) return;
      void queryClient.invalidateQueries({
        queryKey: TAXONOMY_QUERY_KEYS.detail(parsed.data.taxonomyId),
      });
    },
  };
}
